import { render, staticRenderFns } from "./hour.vue?vue&type=template&id=06c4724c&"
import script from "./hour.vue?vue&type=script&lang=js&"
export * from "./hour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports